import { createAvroEventsHub as m } from "@zapier/avro-events";
import { emit as c } from "@zapier/events-toolkit-browser";
import { UserInteractionEvent as a } from "./trackingTypes.es.js";
import { FullStoryAPI as u } from "@zapier/react-fullstory";
const o = "templates", l = (t, e, n) => i(t)(Object.assign({ system_name: n || o }, e || {})), b = (t, e) => {
  const n = Object.assign(Object.assign({}, e), { interaction_name: t });
  return i(a)(n);
};
function i(t) {
  const e = m();
  return e.emitFunction = c, async function(s) {
    const r = Object.assign({ system_name: o }, s);
    u(
      "event",
      // @ts-expect-error // interaction_name might not exist on data
      r.interaction_name || t,
      r
    ), e.emit(r, t);
  };
}
export {
  l as emitEvent,
  b as emitUserInteractionEvent
};
//# sourceMappingURL=emitEvent.es.js.map
